import {useIsLoggedIn} from "UserProvider";
import {referralPrompt, type ReferralPrompt} from "./referralPrompt";
import {useReferralCard} from "./useReferralCard";

/**
 * The success screen's referral offer, as a thin React adapter (epic #26): it reads the two facts the
 * rule needs — whether this is a real account — asks the api only when that is true, and hands the
 * current-site model to {@link referralPrompt}. Every "should this render" decision is in
 * that module, so this file holds no rule of its own.
 *
 * `useIsLoggedIn` rather than `user.isLoggedIn` for the reason that hook exists: it is `false` on the
 * first client render, so the line fades in after hydration instead of diverging from pre-rendered
 * HTML. On this screen that costs nothing — the success card only exists post-upload.
 */
export function useReferralPrompt(): ReferralPrompt | null {
	const signedIn = useIsLoggedIn();
	const {model} = useReferralCard({enabled: signedIn});
	return referralPrompt(signedIn, model);
}
